export default __webpack_public_path__ + "static/media/sword.4d0808f2.png";